import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtService } from 'app/generic/JwtService';
import { NewModalService } from 'app/generic/new-modal/new-modal.service';
import { environment } from 'environments/environment';
import * as CryptoJS from 'crypto-js';
import { TokenGenerator } from 'app/shared/token-generator';

@Injectable({
  providedIn: 'root'
})
export class DatiService extends JwtService {

  // La chiave di crittografia viene letta dai file di ambiente.
  private secretKey = environment.cryptoKey;

  constructor(private http: HttpClient,
    public router: Router,
    public modalComponent: NewModalService) {
    super(router, modalComponent);
  }

  /**
   * Cifra il payload della richiesta usando AES.
   * @param data L'oggetto della richiesta da cifrare.
   * @returns Un oggetto con il payload cifrato.
   */
  private generateSignedPayload(): { payload: any, signature: string } {
  const payload = { timestamp: Date.now() };
  const payloadString = JSON.stringify(payload);
  const signature = CryptoJS.HmacSHA256(payloadString, this.secretKey).toString(CryptoJS.enc.Hex);
  return { payload, signature };
}

richiediDati(request: any, headers?: any): Promise<any> {
  // Usa il body normale (request)
  // Genera l'header custom se non passato
  const customHeaders = headers || {
    'Content-Type': 'application/json',
    'X-Custom-Token': TokenGenerator.generateToken()
  };
  const options = { headers: customHeaders };

  return this.http
    .post(
      environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/recuperodati/richiestaestrazionedati?onLyView=false',
      request, // <-- body normale!
      options
    )
    .toPromise()
    .then(res => res)
    .catch(this.handleError.bind(this));
}

richiediDatiConsultazione(request: any, headers?: any): Promise<any> {
  const customHeaders = headers || {
    'Content-Type': 'application/json',
    'X-Custom-Token': TokenGenerator.generateToken()
  };
  const options = { headers: customHeaders };

  return this.http
    .post(
      environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/recuperodati/richiestaestrazionedati?onlyView=true',
      request, // <-- body normale!
      options
    )
    .toPromise()
    .then(res => res)
    .catch(this.handleError.bind(this));
}

  //https://51.68.89.207:8445/CentroFunzionalePortaleRest/rest/recuperodati/stazioniByFilters
  selectAllStazioniByFilters(): Promise<any> {

    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/recuperodati/stazioniByFilters', super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

  selectAllStazioniByIdTypo(idTipoSensore: any): Promise<any> {

    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/recuperodati/stazioniByFilters?idTipoSensore=' + idTipoSensore, super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

  listAllSensoriByIdStazione(idStazione:any, idTipoSensore: any): Promise<any> {
    let filtroSensore = '&idTipoSensore=' + idTipoSensore

    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/recuperodati/sensoriByFilters'+'?idStazione='+ idStazione + (idTipoSensore == "*" ? "" : filtroSensore) , super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

  selectAllSensoriByIdStazione(idStazione: any): Promise<any> {

    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/recuperodati/stazioniByFilters?idStazione=' + idStazione, super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

  ///export/sensore/{id}/{tipoSensore}
  esportaCSV(idSensore: any, idTipoSensore: any): Promise<any> {

    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/export/sensore/' + idSensore + '/' + idTipoSensore, super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

  selectAllStazioni(): Promise<any> {

    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/utils/getAllStazioni', super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

  selectAllSensoriFromStazione(idStazione: any): Promise<any> {

    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/utils/getSensoriFromIdStazione/' + idStazione, super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

  getMonografiaFromStazione(idStazione: any): Promise<any> {

    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/documenti/getMonografiaFromStazione/' + idStazione, super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

  selectSensoreByIdAndTipo(idSensore: any, tipo: any): Promise<any> {

    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/utils/getSensoreByIdAndTipo/' + idSensore + '/' + tipo, super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

  //https://51.68.89.207:8445/CentroFunzionalePortaleRest/rest/recuperodati/temporeale/36580
  selectSensoreById(idSensore: any): Promise<any> {

    //return this.http.get(environment.apiEndpoint +'/CentroFunzionalePortaleRest/rest/utils/getSensoreByIdAndTipo/'+idSensore, super.getOptions()).toPromise().then(
    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/recuperodati/temporeale/' + idSensore, super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

  exportArchivioSensore(exportBean: any): Promise<any> {

    return this.http.post(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/utils/exportArchivioSensore', exportBean, super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

  //recuperati da vecchio PCF

  selectAllIdrometri(): Promise<any> {

    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/utils/getAllIdrometri', super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

  selectAllBarometri(): Promise<any> {

    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/utils/getAllBarometri', super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }
  selectAllVentoScalare(): Promise<any> {

    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/utils/getAllVentoScalare', super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

  selectAllVentoRaffica(): Promise<any> {

    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/utils/getAllVentoRaffica', super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

  selectAllIgrometri(): Promise<any> {

    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/utils/getAllIgrometri', super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

  selectAllRadiometri(): Promise<any> {

    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/utils/getAllRadiometri', super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

  selectAllPluviometri(): Promise<any> {

    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/utils/getAllPluviometri', super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

  selectAllTermometri(): Promise<any> {

    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/utils/getAllTermometri', super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

}
